/*
 * <sl-promo-timer data-duration="HH:MM:SS"> : compte à rebours de l'offre en cours.
 * Une seule échéance par visiteur (localStorage `sl-promo-timer`), partagée par la barre
 * d'annonce et la page produit. À l'expiration, un nouveau cycle repart de la durée.
 * Le markup fournit [data-h], [data-m], [data-s].
 */
if (!customElements.get('sl-promo-timer')) {
  customElements.define('sl-promo-timer', class extends HTMLElement {
    connectedCallback() {
      // "HH:MM:SS" (ou "MM:SS") → ms ; repli sur 2h47m11s si la saisie est invalide.
      var parts = (this.dataset.duration || '').split(':').map(function (p) { return parseInt(p, 10); });
      var secs = parts.reduce(function (acc, p) { return acc * 60 + (isNaN(p) ? 0 : p); }, 0);
      var DURATION_MS = (secs > 0 ? secs : 10031) * 1000;
      var key = 'sl-promo-timer';
      var h = this.querySelector('[data-h]');
      var m = this.querySelector('[data-m]');
      var s = this.querySelector('[data-s]');

      function read() {
        try { var v = parseInt(localStorage.getItem(key), 10); return isNaN(v) ? 0 : v; } catch (e) { return 0; }
      }
      function renew() {
        var next = Date.now() + DURATION_MS;
        try { localStorage.setItem(key, String(next)); } catch (e) {}
        return next;
      }
      function pad(n) { return n < 10 ? '0' + n : String(n); }

      var endAt = read();
      // Durée raccourcie dans l'éditeur : on ne garde pas une échéance plus lointaine que la durée.
      if (!endAt || endAt <= Date.now() || endAt - Date.now() > DURATION_MS) endAt = renew();

      var tick = function () {
        var remaining = endAt - Date.now();
        if (remaining <= 0) {
          endAt = read() > Date.now() ? read() : renew();
          remaining = endAt - Date.now();
        }
        h.textContent = pad(Math.floor(remaining / 3600000));
        m.textContent = pad(Math.floor((remaining % 3600000) / 60000));
        s.textContent = pad(Math.floor((remaining % 60000) / 1000));
      };
      tick();
      this._interval = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      clearInterval(this._interval);
    }
  });
}
